import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";

import { store } from "../store";

import { numberWithCommas } from "../CustomMath";
import MailService from "../mailService";
import { getFirebaseImageUrl } from "../firebase";

import "../assets/css/cart.css";

const initialState = {
  id: 0,
  title: "",
  firstName: "",
  lastName: "",
  telephone: "",
  email: "",
  addressLine1: "",
  addressLine2: "",
  distance: 0,
  totalQty: 0,
  totalWidth: 0,
  subTotal: 0,
  totalPleats: 0,
  transportationCost: 0,
  fixingCost: 0,
  totalFabricCost: 0,
  total: 0,
  products: [],
};

const AdminCart = () => {
  const [state, setState] = useState({ ...initialState });
  const [dialog, setDialog] = useState(false);
  const [fixing, setFixing] = useState(false);
  const [transport, setTransport] = useState(false);
  const [distance, setDistance] = useState("");
  const service = new MailService();

  useEffect(() => {
    const items = store.getState().items;

    const temp = { ...initialState };
    temp.products = items;

    calculateTotal(temp);
  }, []);

  function calculateFixingCost(e) {
    setFixing(e.value);

    const temp = state;
    temp.fixingCost = 0;

    if (e.value) {
      temp.fixingCost = (state.totalQty <= 2 ? 250 : 200) * state.totalQty;
    }

    setState((prevState) => ({ ...prevState, fixingCost: temp.fixingCost }));
    calculateTotal(temp);
  }

  function calculateTransportCost(e) {
    if (isNaN(e.target.value)) return;

    setDistance(e.target.value);

    const temp = state;
    temp.transportationCost = e.target.value * 175;

    setState((prevState) => ({
      ...prevState,
      transportationCost: temp.transportationCost,
    }));

    calculateTotal(temp);
  }

  function toggleDistance(e) {
    setTransport(e.value);
    setDistance("");
    setState((prevState) => ({
      ...prevState,
      transportationCost: 0,
    }));
  }

  const getLineTotalAfterItemDiscount = (item) => {
    const itemDiscount = item.designDiscountAmount || 0;
    return +item.total - itemDiscount;
  };

  const calculateTotal = (tempState) => {
    if (tempState.products) {
      tempState.totalFabricCost = 0;
      tempState.subTotal = 0;
      tempState.totalWidth = 0;
      tempState.totalQty = 0;
      tempState.totalPleats = 0;

      tempState.products.forEach(function (p) {
        tempState.totalFabricCost += p.item.fabricCost || 0;
        tempState.subTotal += getLineTotalAfterItemDiscount(p.item);

        if (p.item.isPole) {
          tempState.totalWidth += p.item.quantity * p.item.width + 12;
        }

        tempState.totalQty += +p.item.quantity;
        tempState.totalPleats += +(p.item.pleats || 0) * p.item.quantity;
        tempState.total =
          tempState.subTotal +
          tempState.fixingCost +
          tempState.transportationCost;
      });
    }

    setState(tempState);
  };

  const removeItem = (id) => {
    store.dispatch({
      type: "itemRemoved",
      payload: id,
    });

    const updatedProducts = state.products.filter((rem) => rem.id !== id);

    setState((prevState) => ({
      ...prevState,
      products: updatedProducts,
    }));

    const tempState = { ...state, products: updatedProducts };
    calculateTotal(tempState);
  };

  const clearCart = () => {
    store.dispatch({
      type: "itemsCleared",
      payload: [],
    });

    const tempState = { ...initialState };

    setState(tempState);
    calculateTotal(tempState);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    const temp = { ...state };
    temp[name] = value;
    if (name === "distance" && state.transportCostEnabled) {
      temp["transportationCost"] = value * 175;
    }
    setState(temp);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    sendMail();
  };

  const sendMail = async () => {
    const payload = { ...state };

    const order = {
      customerDetails: {
        title: payload.title,
        firstName: payload.firstName,
        lastName: payload.lastName,
        addressLine1: payload.addressLine1,
        addressLine2: payload.addressLine2,
        email: payload.email,
        telephone: payload.telephone,
      },
      orderItems: [],
      orderDetails: {
        distance: distance || 0,
        fixingCost: payload.fixingCost,
        subTotal: payload.subTotal + getTotalItemDiscount(),
        total: payload.total,
        totalFabricCost: payload.totalFabricCost,
        totalPleats: payload.totalPleats,
        totalQty: payload.totalQty,
        totalWidth: inchesToFeet(payload.totalWidth),
        transportationCost: payload.transportationCost,
        discountName: "Item Discounts",
        discountAmount: getTotalItemDiscount(),
      },
    };

    payload.products.forEach((element) => {
      const lineTotal = getLineTotalAfterItemDiscount(element.item);
      const orderItem = {
        selectedDesign: element.item.selectedDesign,
        cost: element.item.cost,
        fabricCost: element.item.fabricCost || 0,
        fabricPrice: element.item.fabricPrice || 0,
        height: element.item.height,
        image: element.item.image,
        poleRequired: element.item.isPole,
        pleats: element.item.pleats || 0,
        price: element.item.price,
        quantity: element.item.quantity,
        total: lineTotal,
        type: element.item.type,
        width: element.item.width,
        discountAmount: element.item.designDiscountAmount || 0,
        discountName: element.item.discountName || "",
      };
      if (element.item.type === "Blind") {
        orderItem.wallMount = element.item.wallMount || "";
        orderItem.pullCordSide = element.item.pullCordSide || "";
        orderItem.frameColor = element.item.frameColor || "";
      }
      // Always include front/back pleats; they'll be 0 for non-double curtains
      orderItem.frontPleats = element.item.frontPleats || 0;
      orderItem.backPleats = element.item.backPleats || 0;
      order.orderItems.push(orderItem);
    });

    setDialog(true);

    const result = await service.postToEndPoint(order);
    if (result.id) clearCart();

    setDialog(false);
  };

  const getTotalItemDiscount = () => {
    if (!state.products) return 0;
    return state.products.reduce(
      (sum, p) => sum + (p.item.designDiscountAmount || 0),
      0
    );
  };

  const inchesToFeet = (inches) => {
    return inches ? Math.ceil(inches / 12) : 0;
  };

  const renderListItem = (dt) => {
    const item = dt.item.selectedDesign;
    return (
      <div>
        <div className="flex w-full mb-3">
          <img
            className="cart-item-image"
            src={getFirebaseImageUrl(item.Image)}
            alt="not found"
            loading="lazy"
          />
          <div className="flex-1 flex justify-content-between ml-3">
            <div className="flex flex-column gap-1">
              <h4>{item.Name}</h4>
              <h5 className="item-specs">Item Code: {item.Code}</h5>
              <div className="desktop-specs">{renderItemSpecs(dt.item)}</div>
              <div className="text-sm">
                Unit Price: LKR {numberWithCommas(dt.item.cost)}
              </div>
              <div className="text-sm">Quantity: {dt.item.quantity}</div>
              {dt.item.designDiscountAmount > 0 && (
                <div className="text-sm" style={{ color: "#d32f2f" }}>
                  Item discount: - LKR {numberWithCommas(dt.item.designDiscountAmount)}
                </div>
              )}
              <div className="font-semibold text-sm">
                Total: LKR {numberWithCommas(getLineTotalAfterItemDiscount(dt.item))}
              </div>
              <Button
                style={{ height: "36px" }}
                icon="pi pi-trash"
                className="p-button-secondary mobile-specs"
                onClick={() => removeItem(dt.id)}
              />
            </div>
            <Button
              icon="pi pi-trash"
              rounded
              className="p-button-secondary desktop-specs"
              onClick={() => removeItem(dt.id)}
            />
          </div>
        </div>
        <div className="mobile-specs mb-4">{renderItemSpecs(dt.item)}</div>
      </div>
    );
  };

  const renderChip = (label, value) => (
    <div className="chip px-2 py-1">
      <div className="border-bottom-1">{label}</div>
      <div className="text-center">{value}</div>
    </div>
  );

  const renderItemSpecs = (item) => {
    // Interior Designs are fixed-size finished products — no measurements to show.
    if (item.type === "Interior Design") {
      return (
        <div className="flex gap-2 text-sm">
          {renderChip("Type", "Interior Design")}
        </div>
      );
    }
    if (item.type === "Blind") {
      return (
        <div className="flex gap-2 text-sm">
          {renderChip("Type", item.type)}
          {renderChip("Width", item.width)}
          {renderChip("Height", item.height)}
          {renderChip("Mount", item.wallMount || "Inside")}
          {renderChip("Pull Cord", item.pullCordSide || "Right")}
          {renderChip("Frame Color", item.frameColor || "A suitable one")}
        </div>
      );
    }
    return (
      <div className="flex gap-2 text-sm">
        {renderChip("Type", item.type)}
        {renderChip("Width", item.width)}
        {renderChip("Height", item.height)}
        {renderChip("Pleats", item.pleats)}
        {renderChip("Pole", item.isPole ? "Yes" : "No")}
      </div>
    );
  };

  const renderAdditionalServices = () => {
    return (
      <div className="flex flex-column gap-2 mb-3">
        <div className="flex justify-content-between">
          <label>Fixing Required</label>
          <InputSwitch
            checked={fixing}
            onChange={(e) => calculateFixingCost(e)}
          />
        </div>
        <hr />
        <div className="flex justify-content-between align-items-center">
          <label>Transport Required</label>
          <div className="flex gap-2 align-items-center">
            {transport ? (
              <InputText
                required
                value={distance}
                onChange={(e) => calculateTransportCost(e)}
                placeholder="Distance: KM"
                className="p-inputtext-sm"
                style={{ maxWidth: "120px" }}
              />
            ) : null}
            <InputSwitch
              checked={transport}
              onChange={(e) => toggleDistance(e)}
            />
          </div>
        </div>
        <hr />
      </div>
    );
  };

  const renderSummery = () => {
    return (
      <div className="card">
        <h3 className="text-center">Order Summary</h3>
        {renderAdditionalServices()}
        <div className="grid">
          <div className="col-12 flex flex-column gap-2">
            <div className="flex justify-content-between">
              <label>Total Quantities</label>
              <label>{state.totalQty}</label>
            </div>
            <div className="flex justify-content-between">
              <label>Pole Width</label>
              <label>{inchesToFeet(state.totalWidth)} ft</label>
            </div>
            <div className="flex justify-content-between">
              <label>Total Pleats</label>
              <label>{state.totalPleats}</label>
            </div>
            <hr />
            <div className="flex justify-content-between">
              <label style={{ fontWeight: 700 }}>Grand Total</label>
              <label style={{ fontWeight: 700 }}>LKR {numberWithCommas(state.subTotal + getTotalItemDiscount())}</label>
            </div>
            <hr />
            <div className="flex justify-content-between">
              <label>Fixing Cost</label>
              <label>LKR {numberWithCommas(state.fixingCost)}</label>
            </div>
            <div className="flex justify-content-between">
              <label>Transportation Cost</label>
              <label>LKR {numberWithCommas(state.transportationCost)}</label>
            </div>
            {getTotalItemDiscount() > 0 && (
              <div className="flex justify-content-between" style={{ color: "#d32f2f" }}>
                <label>Item Discounts</label>
                <label>- LKR {numberWithCommas(getTotalItemDiscount())}</label>
              </div>
            )}
            <hr />
            <div className="cart-total">
              <span>Total</span>
              <span>LKR {numberWithCommas(state.total)}</span>
            </div>
          </div>
          <div className="col-12 flex flex-column pt-3">
            <strong>Please fill your details to get your quotation.</strong>
            <strong>You will receive the quote via an Email</strong>
            <form onSubmit={onSubmit} className="flex flex-column gap-2 mt-3">
              <div className="flex justify-content-between">
                <InputText
                  name="title"
                  required
                  value={state.title}
                  onChange={onChange}
                  placeholder="Title"
                  style={{ width: "60px" }}
                />
                <InputText
                  className="cart-names"
                  name="firstName"
                  required
                  value={state.firstName}
                  onChange={onChange}
                  placeholder="First Name"
                />
                <InputText
                  className="cart-names"
                  name="lastName"
                  value={state.lastName}
                  onChange={onChange}
                  placeholder="Last Name"
                />
              </div>
              <InputText
                name="telephone"
                type="tel"
                required
                value={state.telephone}
                onChange={onChange}
                placeholder="Telephone / Whatsapp Number"
              />
              <InputText
                name="email"
                type="email"
                required
                value={state.email}
                onChange={onChange}
                placeholder="Email"
              />
              <InputText
                name="addressLine1"
                value={state.addressLine1}
                required
                onChange={onChange}
                placeholder="Address Line 1"
              />
              <InputText
                name="addressLine2"
                value={state.addressLine2}
                onChange={onChange}
                placeholder="Address Line 2"
              />
              <Button
                className="p-button-secondary"
                label="Get a Quotation"
                type="submit"
              ></Button>
            </form>
          </div>
        </div>
      </div>
    );
  };

  const renderMyCart = () => {
    return (
      <div className="card flex flex-column mb-5">
        <h3 className="text-center">My Cart</h3>
        <div>
          {state.products.map((item, i) => (
            <React.Fragment key={i}>{renderListItem(item)}</React.Fragment>
          ))}
          <Button
            label="Clear Cart"
            className="p-button-secondary"
            type="button"
            onClick={clearCart}
            style={{ float: "right" }}
          ></Button>
        </div>
      </div>
    );
  };

  return (
    <div style={{ marginBottom: "6rem" }}>
      <div className="content-wrapper">
        <h1 className="mt-3 text-center text-5xl line-height-3">Admin Cart</h1>
        <h5 className="mb-4 text-center">
          Get a quotation for the items in the cart
        </h5>
        <div className="grid">
          <div className="col-7">{renderMyCart()}</div>
          <div className="col-5">{renderSummery()}</div>
        </div>
      </div>
      <Dialog
        visible={dialog}
        style={{ width: "90vw", maxWidth: "300px", textAlign: "center" }}
        closable="false"
      >
        <ProgressSpinner style={{ width: "50px", height: "50px" }} />
        <h6>Please wait ...</h6>
      </Dialog>
    </div>
  );
};

export default AdminCart;
